<h2 mat-dialog-title>
  <span class="filter-by-header">Edit Reports List</span>
</h2>

<mat-dialog-content>
  <form class="w-100 display-flex flex-column grid-gap-8" [formGroup]="form">
    <app-radio-button-dropdown
      class="w-100"
      [multiSelect]="false"
      [items]="summaryTypesList"
      [isLabelInside]="false"
      [allowSearch]="false"
      [allowClear]="false"
      [attrAppendTo]="'body'"
      [containerWidthCss]="'btn-small'"
      formControlName="summaryType"></app-radio-button-dropdown>

    <ng-container *ngIf="showQuickSummaryRowForFilter || filteredOptions?.length > 0; else noReportsTemplate">
      <div class="filter-by-options-container">
        <div
          *ngIf="showQuickSummaryRowForFilter"
          class="quick-summary-wrapper"
          [class.quick-summary-wrapper-disabled]="!quickSummaryEnabled"
          (click)="onQuickSummaryClick($event)">
          <mat-checkbox class="filter-by-label quick-summary-checkbox" [checked]="quickSummaryEnabled" color="primary">
            <app-fade-text [text]="quickSummaryLabel"></app-fade-text>
          </mat-checkbox>
          <div class="quick-summary-overlay"></div>
        </div>

        <div
          *ngIf="filteredOptions?.length > 0"
          class="display-flex flex-column grid-gap-6"
          formGroupName="filterValues">
          <div *ngFor="let option of filteredOptions">
            <mat-checkbox class="filter-by-label" color="primary" [formControlName]="option.value.toString()">
              <app-fade-text [text]="option.label"></app-fade-text>
            </mat-checkbox>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #noReportsTemplate>
      <div class="display-flex align-items-center justify-content-center no-reports-message">No reports to display</div>
    </ng-template>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="display-flex align-items-center justify-content-space-between">
  <button class="summary-filter-by-modal-button" mat-stroked-button color="warn" (click)="cancel()">
    <div class="display-flex align-items-center grid-gap-8">
      <span>Cancel</span>
    </div>
  </button>
  <button
    class="summary-filter-by-modal-button"
    mat-raised-button
    color="primary"
    (click)="save()"
    [disabled]="isSaving">
    <div class="display-flex align-items-center grid-gap-8">
      <mat-progress-spinner *ngIf="isSaving" diameter="20" color="primary" mode="indeterminate"></mat-progress-spinner>
      <span>Save</span>
    </div>
  </button>
</mat-dialog-actions>
